import React, { Component } from 'react';
import { headers, BaseURLDev } from '../../../../../_utils/config';
import { toIDR } from '../../../../../_utils/tocurrency';
import { Form, Loader, Grid, Select, Button, Segment, Menu, Icon, Message } from 'semantic-ui-react';
import { DateRangePicker, isInclusivelyBeforeDay } from 'react-dates';
import moment from 'moment'
import jsPDF from 'jspdf'
import 'jspdf-autotable';
import printJS from 'print-js';
import { getOPD } from '../../../../../_utils/localstorage';

export default class BPHarian extends Component {
    constructor(props){
        super(props);
        this.state = {
            all_data: [],
            requests: false,
            kuasas:'',
            parafs:'',
            kuasa:'',
            paraf:'', 
            kuasan:'',
            parafn:'', 
            tot1:0,
            tot2:0,
            tot3:0,
            jumlah1: 0,
            jumlah3: 0,
            jumlah2: 0,
            jum:0,
            tempat:"",

            opd: "",
            skpd: "",

            startDate: null,
            endDate: null,
            range:"",
        }
        this.getAllData = this.getAllData.bind(this);
        this.onChangeKuasa = this.onChangeKuasa.bind(this);
        this.onChangeParaf = this.onChangeParaf.bind(this); 
        this.onFilter = this.onFilter.bind(this);   
        this.onChangeTempat = this.onChangeTempat.bind(this);  

    }

    onChangeTempat(e, el){
        this.setState({
            tempat:el.value,
        })
     }

    onFilter(){

        const { startDate, endDate } = this.state
        const start_date = startDate===null ? null : startDate.format('YYYY-MM-DD')
        const end_date = endDate===null ? null : endDate.format('YYYY-MM-DD')

        let arr = new Array();
        let dt = new Date(start_date);
        
        while (dt <= new Date(end_date)) {
            arr.push(new Date(dt));
            dt.setDate(dt.getDate() + 1);
        }
  
        this.setState({requests:true,q:""})
        fetch(`${BaseURLDev}/report/retribusibpharian?start=${start_date}&end=${end_date}`, { headers })
        .then(response => {
           if(!response.ok){
              window.alert("Load data gagal")            
              this.setState({data:[],requests:false});
              return Promise.reject(response.statusText);
           }
           return response.json()
        })
        .then(resJSON => {
            let tot1 = 0 
            let tot2 = 0 
            let tot3 = 0
            let jumlah1 = 0
            let jumlah2 = 0
            let jumlah3 = 0
            let rPajak, rRetribusi, rPad
            let tampung = []
            let coba_jumlah  = []
            let jum = Math.max(resJSON.data.rekening.data_retribusi_daerah.length,resJSON.data.rekening.data_lain_pad_sah.length,resJSON.data.rekening.data_pajak_daerah.length);

            let listDate = []
            
            resJSON.data.rekening.data_retribusi_daerah.map(x => {
                if (x.date != "") {
                    listDate.push(x)
                }
            })
            
            
            resJSON.data.rekening.data_pajak_daerah.map(x => {
                if (x.date != "") {
                    listDate.push(x)
                }
            })
            
            resJSON.data.rekening.data_lain_pad_sah.map(x => {
                if (x.date != "") {
                    listDate.push(x)
                }
            })
            

            listDate.map(item => {
                item.date = moment(item.date).format("YYYY-MM-DD")
            })


            let unique = [...new Set(listDate.map(item => item.date))];

            for(var x=0;x<unique.length;x++){
                for(var i=0;i<jum;i++){
                    let tanggal = null
                    if (resJSON.data.rekening.data_retribusi_daerah[i]['date'] != "") {
                        tanggal = moment(resJSON.data.rekening.data_retribusi_daerah[i]['date']).format("YYYY-MM-DD")    
                    }else if (resJSON.data.rekening.data_pajak_daerah[i]['date'] != "") {
                        tanggal = moment(resJSON.data.rekening.data_pajak_daerah[i]['date']).format("YYYY-MM-DD")    
                    }else if (resJSON.data.rekening.data_lain_pad_sah[i]['date'] != "") {
                        tanggal = moment(resJSON.data.rekening.data_lain_pad_sah[i]['date']).format("YYYY-MM-DD")    
                    }
                    
                    if (tanggal == unique[x]) {

                        if(resJSON.data.rekening.data_pajak_daerah[i]['nilai'] != 0){
                            rPajak     = resJSON.data.rekening.data_pajak_daerah[i]['rekening']
                            tot1=tot1+resJSON.data.rekening.data_pajak_daerah[i]['nilai'];
                        }

                        if(resJSON.data.rekening.data_retribusi_daerah[i]['nilai'] != 0){
                            rRetribusi = resJSON.data.rekening.data_retribusi_daerah[i]['rekening']
                            tot2=tot2+resJSON.data.rekening.data_retribusi_daerah[i]['nilai'];
                        }

                        if(resJSON.data.rekening.data_lain_pad_sah[i]['nilai'] != 0){
                            tot3=tot3+resJSON.data.rekening.data_lain_pad_sah[i]['nilai'];
                            rPad       = resJSON.data.rekening.data_lain_pad_sah[i]['rekening']
                        }
                        
                        coba_jumlah[x] == null ? coba_jumlah[x] = 0 : null
                        coba_jumlah[x] += 1

                    }
                }

                let tmp ={
                    "date":{
                        "pajak": unique[x],
                        "retribusi": unique[x], 
                        "pad": unique[x]
                    },
                    "rekening":{
                        "pajak": rPajak,
                        "retribusi": rRetribusi,
                        "pad": rPad
                    },
                    "nilai":{
                        "pajak": tot1,
                        "retribusi": tot2,
                        "pad": tot3
                    }
                }

                rPad = ""
                rPajak = ""
                rRetribusi = ""
                
                jumlah1 += tot1
                jumlah2 += tot2
                jumlah3 += tot3

                tot1 = 0
                tot2 = 0
                tot3 = 0
                tampung[x] = tmp

            }

            this.setState({
                all_data: tampung,
                opd: resJSON.data.opd,
                skpd: resJSON.data.skpd,
                requests: false,
                jum:jum,
                jumlah1,
                jumlah2,
                jumlah3,
                tot1: tot1,
                tot2: tot2,
                tot3: tot3,
                range:moment(start_date).format("DD")+" "+
                    this.getBulan(moment(start_date).format("MM"))+" "+
                    moment(start_date).format("YYYY")  +" s/d "+
                    moment(end_date).format("DD")+" "+
                    this.getBulan(moment(end_date).format("MM"))+" "+
                    moment(end_date).format("YYYY")
            })
            
        })
     }

     onChangeKuasa(e, el){
        this.setState({
            kuasa:this.state.kuasas.find(nama => nama.value == el.value).key,
            kuasan:this.state.kuasas.find(nama => nama.value == el.value).text,
            kuasaj:this.state.kuasas.find(nama => nama.value == el.value).value
        })
     }
     onChangeParaf(e, el){
        this.setState({
           paraf:el.value,
           parafn:this.state.parafs.find(nama => nama.key == el.value).text
        })
     }

    getAllData(){
        this.setState({ requests: true })
        fetch(`${BaseURLDev}/report/retribusibpharian`, { headers })
        .then(response => {
            if(!response.ok){
                this.setState({
                    requests: false
                })
                return Promise.reject(response.statusText);
            }
            return response.json()
        })
        .then(resJSON => {
            var tot1=0; var tot2=0; var tot3=0; var tampung=[]; var retribusi=[]; var pad=[];
            var jum = Math.max(resJSON.data.rekening.data_retribusi_daerah.length,resJSON.data.rekening.data_lain_pad_sah.length,resJSON.data.rekening.data_pajak_daerah.length);
            for(var i=0;i<jum;i++){
                if(resJSON.data.rekening.data_pajak_daerah.length!=0)
                    tot1=tot1+resJSON.data.rekening.data_pajak_daerah[i]['nilai'];
                // if(resJSON.data.rekening.data_retribusi_daerah.length!=0)
                    tot2=tot2+resJSON.data.rekening.data_retribusi_daerah[i]['nilai'];
                if(resJSON.data.rekening.data_lain_pad_sah.length!=0)
                    tot3=tot3+resJSON.data.rekening.data_lain_pad_sah[i]['nilai'];
            }

            var tmp ={
                    "date":{
                        "pajak":resJSON.data.rekening.data_pajak_daerah[0]['date'],
                        "retribusi":resJSON.data.rekening.data_retribusi_daerah[0]['date'],
                        "pad":resJSON.data.rekening.data_lain_pad_sah[0]['date']
                    },
                    "rekening":{
                        "pajak":resJSON.data.rekening.data_pajak_daerah[0]['rekening'],
                        "retribusi":resJSON.data.rekening.data_retribusi_daerah[0]['rekening'],
                        "pad":resJSON.data.rekening.data_lain_pad_sah[0]['rekening']
                    },
                    "nilai":{
                        "pajak": tot1,
                        "retribusi": tot2,
                        "pad": tot3
                    }
                }
                tampung[0]=tmp;

            this.setState({
                all_data: tampung,
                opd: resJSON.data.opd,
                skpd: resJSON.data.skpd,
                requests: false,
                jum:jum,
                tot1: tot1,
                tot2: tot2,
                tot3: tot3,
                range: this.getBulan(moment().format("MM"))+" "+moment().format("YYYY")
            })
            
        })
    }

    getDataParaf(){
        fetch(`${BaseURLDev}/paraf`, { headers })
        .then(response => {
            if(!response.ok){
                return Promise.reject(response.statusText);
            }
            return response.json()
        })
        .then(resJSON => {
            const parafs = []
            resJSON.data.map((item,i)=>{
                parafs.push({
                'value': `${item.kode}`,
                'text': `${item.nama}`,
                'key': `${item.kode}`      
                })
                return false
            })
            this.setState({parafs:parafs})
            return false
        })
    }

    getDataKuasa(){
        fetch(`${BaseURLDev}/kuasa`, { headers })
        .then(response => {
            if(!response.ok){
                return Promise.reject(response.statusText);
            }
            return response.json()
        })
        .then(resJSON => {
            const kuasas = []
            resJSON.data.map((item,i)=>{
                kuasas.push({
                'value': `${item.jabatan}`,
                'text': `${item.nama}`,
                'key': `${item.kode}`      
                })
                return false
            })
            this.setState({kuasas:kuasas})
            return false
        })
    }

    componentDidMount(){
        // this.getAllData()
        this.getDataKuasa()
        this.getDataParaf()
    }

    exportDownload(){
        window.location='/b/TemplateReport';
    }

    exportData(){
        var pdf = new jsPDF('landscape');

        var specialElementHandlers = {
            'DIV to be rendered out': function(element, renderer){
             return true;
          }
        };
        
        var source = document.getElementById("print_data");
        pdf.autoTable({
            html: source
        });
        pdf.save(`${moment().format("DD_MM_YYYY_HH_mm_ss")}.pdf`);
    }

    getBulan(e){
        if(e=='01') return 'Januari'
        else if(e=='02') return 'Februari'
        else if(e=='03') return 'Maret'
        else if(e=='04') return 'April'
        else if(e=='05') return 'Mei'
        else if(e=='06') return 'Juni'
        else if(e=='07') return 'Juli'
        else if(e=='08') return 'Agustus'
        else if(e=='09') return 'September'
        else if(e=='10') return 'Oktober'
        else if(e=='11') return 'November'
        else if(e=='12') return 'Desember'
    }

    exportData(){
        printJS({
            printable: 'print_data',
            type: 'html',
            modalMessage:"Sedang memuat data...",
            showModal:true,
            maxWidth:'1300',
            font_size:'8pt',
            documentTitle:'Print BP',
            targetStyle: [
                'margin',
                'color',
                'border-collapse',
                'border-spacing',
                'border-style',
                'border-style',
                'margin-bottom',
                'padding',
                'Label',
                'background'
            ]
        })
     }

    render() {
        const { requests, all_data, opd } = this.state;
        const styletb = {
            borderCollapse:'collapse',
            borderSpacing:0,
            borderStyle:'solid',
            width:'100%',
            fontSize:'12px'
        }
        return (
            <div>
                <Message
                    error
                    header='*** Penting!'
                    content='Silahkan memilih Rentang Tanggal terlebih dahulu sebelum menekan tombol Filter'
                /> 
                <Menu>
                    <Menu.Item>
                    <DateRangePicker
                           hideKeyboardShortcutsPanel
                           reopenPickerOnClearDates
                           showClearDates
                           minimumNights={0}
                           withPortal
                           showDefaultInputIcon
                           displayFormat="DD/MM/YYYY"
                           small={true}                              
                           numberOfMonths={2}
                           startDatePlaceholderText="Awal"
                           endDatePlaceholderText="Akhir"
                           startDateId="startDateId"
                           endDateId="endDateId"
                           isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
                           startDate={this.state.startDate}
                           endDate={this.state.endDate}
                           onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })}
                           focusedInput={this.state.focusedInput}
                           onFocusChange={(focusedInput) => this.setState({ focusedInput })}
                        />
                    </Menu.Item>
                    <Menu.Item>                      
                        <Button content="Filter" color='green' icon='filter' onClick={this.onFilter}/>
                    </Menu.Item>
                </Menu>
                {
                requests ? <Loader active inline='centered' size='medium'>Loading...</Loader>:
                    <Grid>
                        <Grid.Column width={16}>
                        {/* <Segment> */}
                            <div>
                                <Menu>
                                    <Menu.Item>
                                        <Form.Field 
                                            control={Select} 
                                            search 
                                            onChange={this.onChangeKuasa} 
                                            options={this.state.kuasas} 
                                            name="kuasa" 
                                            placeholder='Pilih KPA'
                                            ttile='Pilih KPA'
                                        />
                                    </Menu.Item>
                                    <Menu.Item>
                                        <Form.Field 
                                            control={Select} 
                                            search 
                                            onChange={this.onChangeParaf} 
                                            options={this.state.parafs} 
                                            name="paraf" 
                                            placeholder='Pilih Bendahara Penerima'
                                            ttile='Pilih Bendahara Penerima'
                                        /> 
                                    </Menu.Item>
                                    <Menu.Item>
                                        <Form.Input placeholder='Masukan Tempat' type='text' onChange={this.onChangeTempat}/>
                                    </Menu.Item>
                                    <Menu.Item position="right">
                                        <Button color='blue' size="small" onClick={()=>this.exportData()}> 
                                            <p><Icon name='print' className='left floated' />Preview</p>
                                        </Button>
                                    </Menu.Item>
                                </Menu>
                                <Segment>
                                    <div id="print_data">
                                        <table align="center" width="100%" style={{fontSize:'12px'}}>
                                            <tbody>
                                                <tr align="center">
                                                <th colSpan="2">
                                                    <p style={{marginBottom: '25px'}}>PROVINSI NUSA TENGGARA BARAT<br />
                                                    BUKU REKAPITULASI PENERIMAAN HARIAN
                                                    </p>
                                                </th>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table width="100%" style={{fontSize:'12px'}}>
                                            <tbody>
                                                <tr align="left" className="txt-left">
                                                    <td className="txt-left" width="30%" align="left">OPD</td>
                                                    <td className="txt-left" align="left">&nbsp;:&nbsp;{opd != "" ? getOPD(opd) : null}</td>
                                                </tr>
                                                <tr align="left" className="txt-left">
                                                    <td className="txt-left" width="30%" align="left">KPA</td>
                                                    <td className="txt-left" align="left">&nbsp;:&nbsp;{this.state.kuasan}</td>
                                                </tr>
                                                <tr align="left" className="txt-left" >
                                                    <td className="txt-left" width="30%" align="left">BENDAHARA PENERIMA</td>
                                                    <td className="txt-left" align="left">&nbsp;:&nbsp;{this.state.parafn}</td>
                                                </tr>
                                                <tr align="left" className="txt-left">
                                                    <td className="txt-left" width="30%" align="left">BULAN</td>
                                                    {/* <td className="txt-left" align="left">&nbsp;:&nbsp;{this.getBulan(moment().format("MM"))+" "+moment().format("YYYY")}</td> */}
                                                    <td className="txt-left" align="left">&nbsp;:&nbsp;{this.state.range}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <br/>
                                        <table border="1" align="center" style={styletb} width="100%">
                                            <tbody>            
                                                <tr align="left" style={{background:'#e5e5e5',padding:'4px'}}>
                                                    <th rowSpan="2" style={{padding:'4px',textAlign:'center',width:'4%'}}>Nomor Urut</th>
                                                    <th rowSpan="2" style={{padding:'4px',textAlign:'center'}}>Tanggal</th>
                                                    <th rowSpan="2" style={{padding:'4px',textAlign:'center'}}>Referensi</th>
                                                    <th colSpan="2" style={{padding:'4px',textAlign:'center'}}>PAJAK DAERAH (Rp)</th>
                                                    <th colSpan="2" style={{padding:'4px',textAlign:'center'}}>RETRIBUSI DAERAH (Rp)</th>
                                                    <th colSpan="2" style={{padding:'4px',textAlign:'center'}}>LAIN2 PAD YG SAH (Rp)</th>
                                                </tr>
                                                <tr align="left" style={{background:'#e5e5e5',padding:'4px'}}>
                                                    <td style={{padding:'4px',textAlign:'center'}}>
                                                        Kode dan nama <br/> 
                                                        Kode Rekening <br/>
                                                        Rincian Objek
                                                    </td>
                                                    <td style={{padding:'4px',textAlign:'center'}}>
                                                        Kode dan nama <br/> 
                                                        Kode Rekening <br/>
                                                        Rincian Objek (Rp)
                                                    </td>

                                                    <td style={{padding:'4px',textAlign:'center'}}>
                                                        Kode dan nama <br/> 
                                                        Kode Rekening <br/>
                                                        Rincian Objek
                                                    </td>
                                                    <td style={{padding:'4px',textAlign:'center'}}>
                                                        Kode dan nama <br/> 
                                                        Kode Rekening <br/>
                                                        Rincian Objek (Rp)
                                                    </td>

                                                    <td style={{padding:'4px',textAlign:'center'}}>
                                                        Kode dan nama <br/> 
                                                        Kode Rekening <br/>
                                                        Rincian Objek
                                                    </td>
                                                    <td style={{padding:'4px',textAlign:'center'}}>
                                                        Kode dan nama <br/> 
                                                        Kode Rekening <br/>
                                                        Rincian Objek (Rp)
                                                    </td>
                                                </tr>
                                                <tr align="left" style={{background:'#e5e5e5',padding:'4px'}}>
                                                    <td style={{padding:'4px',textAlign:'center'}}>1</td>
                                                    <td style={{padding:'4px',textAlign:'center'}}>2</td>
                                                    <td style={{padding:'4px',textAlign:'center'}}>3</td>
                                                    <td style={{padding:'4px',textAlign:'center'}}>4</td>
                                                    <td style={{padding:'4px',textAlign:'center'}}>5</td>
                                                    <td style={{padding:'4px',textAlign:'center'}}>6</td>
                                                    <td style={{padding:'4px',textAlign:'center'}}>7</td>
                                                    <td style={{padding:'4px',textAlign:'center'}}>8</td>
                                                    <td style={{padding:'4px',textAlign:'center'}}>9</td>
                                                </tr>
                                                { 
                                                    this.state.jum === 0 && <tr> <td colSpan="9" style={{padding:'4px',textAlign:'center'}}>Data Kosong</td> </tr> 
                                                }
                                                {
                                                    all_data.map((item,i) => (
                                                        <tr key={i}>  
                                                            <td style={{padding:'4px',textAlign:'center'}}>{i+1}</td>
                                                            <td style={{padding:'4px',textAlign:'center'}}>
                                                            { 
                                                                (item.date.retribusi == undefined)? null:
                                                                moment(item.date.retribusi).format("DD")+" "+this.getBulan(moment(item.date.retribusi).format("MM"))+" "+moment(item.date.retribusi).format("YYYY")
                                                            }
                                                            </td>
                                                            <td style={{padding:'4px',textAlign:'center'}}> </td>
                                                            <td style={{padding:'4px',textAlign:'center'}}>{item.rekening.pajak}</td>
                                                            <td style={{padding:'4px',textAlign:'center'}}>{ item.nilai.pajak==0? "":
                                                                toIDR(item.nilai.pajak)}</td>
                                                            <td style={{padding:'4px',textAlign:'center'}}>{item.rekening.retribusi}</td>
                                                            <td style={{padding:'4px',textAlign:'center'}}>{ item.nilai.retribusi==0? "":
                                                                toIDR(item.nilai.retribusi)}</td>
                                                            <td style={{padding:'4px',textAlign:'center'}}>{item.rekening.pad}</td>
                                                            <td style={{padding:'4px',textAlign:'center'}}>{ item.nilai.pad==0? "":
                                                                toIDR(item.nilai.pad)}</td>
                                                        </tr> 
                                                    ))
                                                }
                                                <tr align="left" style={{background:'#e5e5e5',padding:'4px'}}>
                                                    <td colSpan="3" style={{padding:'4px',textAlign:'right'}}>JUMLAH</td>
                                                    <td> </td>
                                                    <td style={{padding:'4px',textAlign:'center'}}>{ this.state.jumlah1 ==0 ? "":
                                                        toIDR(this.state.jumlah1)}</td>
                                                    <td style={{padding:'4px',textAlign:'center'}}> </td>
                                                    <td style={{padding:'4px',textAlign:'center'}}>{ this.state.jumlah2 ==0 ? "":
                                                        toIDR(this.state.jumlah2)}</td>
                                                    <td style={{padding:'4px',textAlign:'center'}}> </td>
                                                    <td style={{padding:'4px',textAlign:'center'}}>{ this.state.jumlah3 ==0 ? "":
                                                        toIDR(this.state.jumlah3)}</td>
                                                </tr>
                                            </tbody>            
                                        </table>
                                        
                                        <table width="100%" style={{marginTop:'30px',fontSize:'12px'}}>
                                            <tbody>
                                            <tr>
                                                <td align="center">
                                                {
                                                    (this.state.kuasa==="")? null :
                                                    <b>Mengetahui <br/> {this.state.kuasaj} <br/><br/><br/>{this.state.kuasan}<br/>NIP. {this.state.kuasa}</b>
                                                }
                                                </td>
                                                <td align="center">
                                                {
                                                    (this.state.parafn==="")? null : 
                                                    <b>{this.state.tempat}, {moment().format("DD")+" "+this.getBulan(moment().format("MM"))+" "+moment().format("YYYY")} 
                                                    <br/> Bendahara Penerima <br/><br/><br/>{this.state.parafn}<br/>NIP. {this.state.paraf}</b>
                                                }
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </Segment>
                            </div>
                        {/* </Segment> */}
                        </Grid.Column>
                    </Grid>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_report/BPHarian.js